import {visionInfoParse} from "@/api/file_vision_process";
import {fileStatusChange} from "@/components/file_process_js/utils";
import {gbrFileVisionProcess} from "@/components/file_process_js/pubilc_md/file_vision_process_by_local/gerber_vision";
import {getFileUrl} from "@/api/oss";
import {OcrResultProcessor} from "@/components/file_process_js/ function_process/vision_box_process";
import {txtFileVisionProcess} from "@/components/file_process_js/pubilc_md/file_vision_process_by_local/txt_vision";


export async function commonFileVisionMd(fileInfo) {

    console.log("end commonFileVisionMd");
    await getVisionParseRse(fileInfo)
    await fixPDFRatio(fileInfo)
    applyVisionParseRse(fileInfo)
    applyFileFullText(fileInfo)
    fileStatusChange(fileInfo)
}

export async function gerberFileVisionMd(fileInfo) {
    const visionKey = await gbrFileVisionProcess(fileInfo)
    if (!visionKey) {
       console.error("gerberFileVisionMd error", fileInfo)
        return
    }
    await visionInfoParse(fileInfo, fileInfo.project_id, visionKey).then(res => {
        applyVisionParseRse(fileInfo, res)
    }).catch(error => {
        console.log("fileVisionMd err", error);
    })
}

async function getVisionParseRse(fileInfo) {

    if (fileInfo.status_code >= 199 || fileInfo.status_code < 0) {
        return
    }

    let version_key = ""

    console.log("start commonFileVisionMd");
    let transformApi = ()=> {}
    if (["pdf", "doc", "xls", "xlsx", "image"].includes(fileInfo.file_type)) {
        transformApi = visionInfoParse
    } else if (fileInfo.file_type === "txt") {
        version_key = await txtFileVisionProcess(fileInfo)
        if (!version_key) {
            return
        }
        transformApi = visionInfoParse

    }else if (fileInfo.file_type === "drl") {
        fileStatusChange(fileInfo, "暂时关闭", -100);
        return
    } else if (fileInfo.file_type === "eml") {
        fileStatusChange(fileInfo, "暂时关闭", -100);
        return
    } else {
        console.error("invalid fileInfo.file_type", fileInfo.file_type)
        return
    }
    try{
        const visionRes = await transformApi(fileInfo, fileInfo.project_id, version_key)
        if (visionRes && visionRes["data"] && visionRes["data"]["content_result"]){
            const visionInfo = visionRes["data"]["content_result"]
            if (!visionInfo) {
                fileStatusChange(fileInfo, "可视化失败，请重试", -190);
                console.error("fileVisionMd got unexpect res", visionRes)
                return
            }
            fileInfo.file_vision = visionInfo
            fileStatusChange(fileInfo, "vision done", 199);
        }else {
            fileStatusChange(fileInfo, "可视化失败，请稍后重试", -190);
            console.error("fileVisionMd got unexpect res", visionRes)
        }
    } catch(err) {
        fileStatusChange(fileInfo, "可视化失败，请稍后重试", -190);
        console.error("fileVisionMd got err, fileInfo", err, fileInfo)
    }

}

function applyVisionParseRse(fileInfo) {
    const fileImageKeys = []
    const fileVisionRatios = []
    fileInfo.file_vision.forEach(visionRes => {
        if (visionRes['img_key']) {
            fileImageKeys.push(getFileUrl(fileInfo.project_id, visionRes['img_key']))
        }
        fileVisionRatios.push(visionRes['ratio']? visionRes['ratio']: 1)
    })
    fileInfo.file_image_keys = fileImageKeys
    fileInfo.vision_ratio = fileVisionRatios
}

function applyFileFullText(fileInfo) {
    const fileBoxProcessor = new OcrResultProcessor(fileInfo.file_vision)
    const textRes = fileBoxProcessor.getPagesText()
    if (textRes || textRes.length === 0) {
        console.log("empty applyFileFullText", fileInfo, textRes)
    }
    fileInfo.text_content = textRes
    fileInfo.boxProcessor = fileBoxProcessor
    // console.log("applyFileFullText", fileInfo, JSON.stringify(fileInfo.text_content))
}

function getImageSize(url) {
    return new Promise((resolve) => { // 即使失败也 resolve，避免 Promise.all 挂掉
        const img = new Image();
        img.onload = () => {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
                success: true
            });
        };
        img.onerror = () => {
            console.warn(`图片加载失败: ${url}`);
            resolve({ success: false }); // 失败也返回，标记为 false
        };

        img.src = url;
    });
}

async function fixPDFRatio(fileInfo) {
    // 1. 创建一个处理单个 item 的异步任务
    const tasks = fileInfo.file_vision.map(async (visionRes) => {
        const page_width = visionRes["text_content"]?.["page_width"];
        const oldRatio = visionRes['ratio'];

        // 只有满足条件才进行网络请求
        if (oldRatio && page_width) {
            const img_key = visionRes['img_key'];
            const img_url = getFileUrl(fileInfo.project_id, img_key);

            // 获取尺寸
            const size = await getImageSize(img_url);
            console.log("end getImageSize")
            if (size.success) {
                // 只有在确实需要修改时才赋值，减少 Vue 响应式触发
                if (Math.abs(page_width * parseFloat(oldRatio) - size.width) > 1) { // 允许 1px 误差
                    const newRatio = size.width / page_width;
                    // 直接修改对象属性
                    visionRes['ratio'] = newRatio;
                    console.log(`fixPDFRatio PDF 比例自适应调整; 原始比例:${oldRatio}; 纠正比例:${newRatio}; page_width: ${page_width}; image_width: ${size.width}`);
                } else {
                    console.log("fixPDFRatio PDF 文件比例一致，无需调整  ")
                }
            } else {
                console.log("getImageSize", size)
            }
        }
    });

    // 2. 并行执行所有任务
    console.log("开始并行校正图片比例...");
    await Promise.all(tasks);
    console.log("图片比例校正结束");
}

// export function getFileImageMd(fileInfo) {
//     const fileConfig = store.state.fileConfig
//     const fileImageConfig = fileConfig.file_image_config
//
//     const allowFileType = fileImageConfig.allow_file_type
//     const allowFilePathWord = fileImageConfig.allow_file_path_word
//     const notAllowFileType = fileImageConfig.not_allow_file_type
//     const notAllowFilePathWord = fileImageConfig.not_allow_file_path_word
//
//     const fileIsAllowed = isAllowed(fileInfo.file_path, fileInfo.file_type, allowFileType, allowFilePathWord, notAllowFileType, notAllowFilePathWord)
//
//     return fileIsAllowed ? fileVisionMd : null
// }